import { useState } from "react";
import RadioButton from "./RadioButton";
import ButtonIconH from "./ButtonIconH";
import InputData from "./InputData";
import "../css/ReportPopup.css";

export function ContactLensesReportPopup({
  createPopupQuestion,
  removePopupQuestion,
  onExport,
  onGenerateOfficialPrescription,
  onClose,
}) {
  const [options, setOptions] = useState({
    record: 0, // 0: current, 1: work order, 2: prescription 3: official prescription
    observations: true,
    email: "",
  });
  const [errorEmail, setErrorEmail] = useState(false);

  // console.log("options: ", options);

  const checkEmail = () => {
    if (errorEmail || options.email === "") {
      createPopupQuestion(
        "Por favor, introduzca un email correcto.",
        () => {
          setErrorEmail(false);
          removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  };

  return (
    <div className="popup-container" style={{ zIndex: 11 }}>
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Informe de lentes de contacto
          </span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon" />
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div
            className="container-panel"
            style={{ display: "flex", flexDirection: "column", gap: 20 }}
          >
            <div className="opt-table-content grid-7" id="lc-report-grid">
              <div className="cell cell-start-content">
                <div
                  className="data-field"
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      record: 0,
                    }));
                  }}
                >
                  <RadioButton active={options.record === 0}></RadioButton>
                  <span>Ficha de LC</span>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                <div
                  className="data-field"
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      record: 1,
                    }));
                  }}
                >
                  <RadioButton active={options.record === 1}></RadioButton>
                  <span>Orden de trabajo</span>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                <div
                  className="data-field"
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      record: 2,
                    }));
                  }}
                >
                  <RadioButton active={options.record === 2}></RadioButton>
                  <span>Receta</span>
                </div>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">
                <div
                  className="data-field"
                  onClick={() => {
                    setOptions((prev) => ({
                      ...prev,
                      record: 3,
                    }));
                  }}
                >
                  <RadioButton active={options.record === 3}></RadioButton>
                  <span>Receta oficial CGCOO</span>
                </div>
              </div>
              {options.record !== 3 && (
                <>
                  <div className="cell cell-start-content">Observaciones</div>
                  <div className="cell cell-start-content combined-cells-6">
                    <div className="radio-ops-container" style={{ gap: 20 }}>
                      <div
                        className="data-field"
                        onClick={() => {
                          setOptions((prev) => ({
                            ...prev,
                            observations: true,
                          }));
                        }}
                      >
                        <RadioButton active={options.observations}></RadioButton>
                        <span>Sí</span>
                      </div>
                      <div
                        className="data-field"
                        onClick={() => {
                          setOptions((prev) => ({
                            ...prev,
                            observations: false,
                          }));
                        }}
                      >
                        <RadioButton active={!options.observations}></RadioButton>
                        <span>No</span>
                      </div>
                    </div>
                  </div>
                  <div className="cell cell-start-content combined-cells-7">
                    <div className="data-field" style={{ width: "100%" }}>
                      <span>Email</span>
                      <InputData
                        type="type-email"
                        size={0}
                        input={options.email}
                        onChange={(e) => {
                          setOptions((prev) => ({
                            ...prev,
                            email: e,
                          }));
                        }}
                        onMalformed={() => setErrorEmail(true)}
                        error={errorEmail}
                      ></InputData>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="popup-buttons" style={{ justifyContent: "center" }}>
              {options.record === 3 ? (
                <ButtonIconH
                  text="Generar receta"
                  onClick={() => {
                    onGenerateOfficialPrescription(options);
                  }}
                ></ButtonIconH>
              ) : (
                <>
                  <ButtonIconH
                    text="Enviar email"
                    onClick={() => {
                      onExport(options);
                    }}
                  ></ButtonIconH>
                  <ButtonIconH
                    text="Exportar PDF"
                    onClick={() => {
                      onExport(options);
                    }}
                  ></ButtonIconH>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
